import { PartnerBadgeEnum } from "@/types";
import { useFarbwelt } from "../useFarbwelt";
import { useClassified } from "@/contexts/classified";
const badgeMappings = {
    [PartnerBadgeEnum.platin]: "loyalty-platinum",
    [PartnerBadgeEnum.diamond]: "loyalty-diamond",
    [PartnerBadgeEnum.simple]: "loyalty-immowelt",
    [PartnerBadgeEnum.business]: "loyalty-business",
    [PartnerBadgeEnum.premium]: "loyalty-premium",
};
export const useTrackingPromotion = () => {
    var _a, _b, _c;
    const { isFarbweltActive } = useFarbwelt();
    const badges = (_c = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.contactSections) === null || _b === void 0 ? void 0 : _b.provider) === null || _c === void 0 ? void 0 : _c.badges;
    if (!isFarbweltActive && !(badges === null || badges === void 0 ? void 0 : badges.length))
        return undefined;
    const promotions = isFarbweltActive ? ["farbwelt"] : [];
    if (badges === null || badges === void 0 ? void 0 : badges.length) {
        const badgePromotions = badges
            .map((badge) => badgeMappings[badge.title])
            .filter(Boolean);
        if (badgePromotions.length) {
            promotions.push(...badgePromotions);
        }
    }
    return promotions.length ? promotions.join("|") : undefined;
};
